var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuyana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C31.0457 39.9999 40 31.0456 40 19.9999C40 8.95421 31.0457 -9.15527e-05 20 -9.15527e-05C8.9543 -9.15527e-05 0 8.95421 0 19.9999C0 31.0456 8.9543 39.9999 20 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 -9.15527e-05C16.464 -9.15527e-05 13.1431 0.918815 10.2609 2.52897V37.4708C13.1431 39.081 16.464 39.9999 20 39.9999C31.0456 39.9999 40 31.0455 40 19.9999C40 8.95428 31.0456 -9.15527e-05 20 -9.15527e-05Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3196 2.49612C9.06139 3.19339 7.88655 4.02214 6.81319 4.96433C6.9217 4.86917 7.03131 4.77511 7.14178 4.6823L22.4594 20L7.1417 35.3176C7.03116 35.2248 6.92163 35.1307 6.81311 35.0356C7.88647 35.9778 9.06139 36.8064 10.3195 37.5038L39.9999 20L10.3196 2.49612Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63045 3.54538C8.02053 3.96772 7.43475 4.42218 6.87654 4.90788L20 19.9999L6.87646 35.0919C7.43467 35.5776 8.02045 36.0322 8.63037 36.4544L36.5764 19.9999L8.63045 3.54538Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14177 4.68231C6.69716 5.05591 6.2681 5.44755 5.85779 5.85778L18.2608 20L5.85779 34.1422C6.2681 34.5525 6.69708 34.9442 7.14177 35.3176L22.4594 20L7.14177 4.68231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85785 5.85773C-1.95262 13.6682 -1.95262 26.3316 5.85785 34.1421C9.08543 30.9145 12.1896 27.8104 20 19.9999L5.85785 5.85773Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuyana);
export default __webpack_public_path__ + "static/media/guyana.6303e2f8634976452379020eeac54ee0.svg";
export { ForwardRef as ReactComponent };